export const lightsPhysicalFragmentWithSpecColorChunk = `PhysicalMaterial material;
material.diffuseColor = diffuseColor.rgb * ( 1.0 - metalnessFactor );

vec3 dxy = max( abs( dFdx( geometryNormal ) ), abs( dFdy( geometryNormal ) ) );
float geometryRoughness = max( max( dxy.x, dxy.y ), dxy.z );

material.roughness = max( roughnessFactor, 0.0525 );// 0.0525 corresponds to the base mip of a 256 cubemap.
material.roughness += geometryRoughness;
material.roughness = min( material.roughness, 1.0 );

#ifdef IOR

  material.ior = ior;

  #ifdef SPECULAR

    float specularIntensityFactor = specularIntensity;
    vec3 specularColorFactor = specularColor;

    #ifdef USE_SPECULARINTENSITYMAP

      specularIntensityFactor *= texture2D( specularIntensityMap, vUv ).a;

    #endif

    #ifdef USE_SPECULARCOLORMAP

      specularColorFactor *= texture2D( specularColorMap, vUv ).rgb;

    #endif

    material.specularF90 = mix( specularIntensityFactor, 1.0, metalnessFactor );

  #else

    float specularIntensityFactor = 1.0;
    vec3 specularColorFactor = vec3( 1.0 );
    material.specularF90 = 1.0;

  #endif

  material.specularColor = mix( min( pow2( ( material.ior - 1.0 ) / ( material.ior + 1.0 ) ) * specularColorFactor, vec3( 1.0 ) ) * specularIntensityFactor, dmSpecColor.rgb, metalnessFactor );

#else

  material.specularColor = mix( vec3( 0.04 ), dmSpecColor.rgb, metalnessFactor );
  material.specularF90 = 1.0;

#endif

#ifdef USE_CLEARCOAT

  material.clearcoat = clearcoat;
  material.clearcoatRoughness = clearcoatRoughness;
  material.clearcoatF0 = vec3( 0.04 );
  material.clearcoatF90 = 1.0;

  #ifdef USE_CLEARCOATMAP

    material.clearcoat *= texture2D( clearcoatMap, vUv ).x;

  #endif

  #ifdef USE_CLEARCOAT_ROUGHNESSMAP

    material.clearcoatRoughness *= texture2D( clearcoatRoughnessMap, vUv ).y;

  #endif

  material.clearcoat = saturate( material.clearcoat ); // Burley clearcoat model
  material.clearcoatRoughness = max( material.clearcoatRoughness, 0.0525 );
  material.clearcoatRoughness += geometryRoughness;
  material.clearcoatRoughness = min( material.clearcoatRoughness, 1.0 );

#endif

#ifdef USE_IRIDESCENCE

  material.iridescence = iridescence;
  material.iridescenceIOR = iridescenceIOR;

  #ifdef USE_IRIDESCENCEMAP

    material.iridescence *= texture2D( iridescenceMap, vUv ).r;

  #endif

  #ifdef USE_IRIDESCENCE_THICKNESSMAP

    material.iridescenceThickness = (iridescenceThicknessMaximum - iridescenceThicknessMinimum) * texture2D( iridescenceThicknessMap, vUv ).g + iridescenceThicknessMinimum;

  #else

    material.iridescenceThickness = iridescenceThicknessMaximum;

  #endif

#endif

#ifdef USE_SHEEN

  material.sheenColor = sheenColor;

  #ifdef USE_SHEENCOLORMAP

    material.sheenColor *= texture2D( sheenColorMap, vUv ).rgb;

  #endif

  material.sheenRoughness = clamp( sheenRoughness, 0.07, 1.0 );

  #ifdef USE_SHEENROUGHNESSMAP

    material.sheenRoughness *= texture2D( sheenRoughnessMap, vUv ).a;

  #endif

#endif
`;
